// extracted by mini-css-extract-plugin
export default {"logo":"hFffkfg6l5V1ItluUJ02"};